export async function handleResponse(response) {
  if (response.status === 200) return response.data;
  if (response.status === 400) {
    // Handle server-side validations
    console.log(response);
    throw new Error("Server-side validation error.");
  }
  if (response.status === 204) {
    // Treat 204 as a successful response
    return Promise.resolve(); // Or resolve with any relevant data
  }
  throw new Error(`Bad response : ${response.status}`);
}

export function handleError(error) {
  try {
    if (error && error.response && (error.response.status === 401 || error.response.status === 403)) {
      try {
        const auth = require("../utils/AuthUtil").default.getService();
        auth.removeLocalStore();
      } catch (e) {
        console.error("Error clearing local storage:");
      }
      window.location.replace("/");
      return;
    }
  } catch (e) {}
  console.log("API call failed. " + error);
  throw error;
}
